import { BootstrapJQ } from '../../models';
import { FancyMessagePaneState } from '../fancy-message-pane/fancy-message-pane';

export type OligoModalType = string;

export const OligoModalTypes: {
  INFO: OligoModalType;
  CONFIRM: OligoModalType;
} = {
  INFO: 'INFO',
  CONFIRM: 'CONFIRM',
};

export type OligoModalSupportStatus = 'OK' | 'CANCEL' | 'CLOSE';

export const OligoModalSupportStatuses: {
  OK: OligoModalSupportStatus;
  CANCEL: OligoModalSupportStatus;
  CLOSE: OligoModalSupportStatus;
} = {
  OK: 'OK',
  CANCEL: 'CANCEL',
  CLOSE: 'CLOSE',
};

export type OligoModalSupportOptions = {
  title: string;
  content: string;
  type: OligoModalType;
  okLabel?: string;
  cancelLabel?: string;
  alertData?: {
    state: FancyMessagePaneState;
    content: string;
  };
};

export type OligoModalSupport = {
  data?: OligoModalSupportOptions;
  show(options: OligoModalSupportOptions): ng.IPromise<OligoModalSupportStatus>;
  hide(status: OligoModalSupportStatus): void;
};

const MODAL_ID: string = 'oligo-modal-support';

export const OLIGO_MODAL_SUPPORT_SERVICE_NAME: string = 'oligoModalSupportService';
export class OligoModalSupportService implements OligoModalSupport {

  public data?: OligoModalSupportOptions;
  private deferred?: ng.IDeferred<OligoModalSupportStatus>;
  private jq?: BootstrapJQ;

  constructor(private $q: ng.IQService) {
  }

  public show(options: OligoModalSupportOptions): ng.IPromise<OligoModalSupportStatus> {
    this.data = options;
    this.deferred = this.$q.defer();
    this.getJQ().modal({
      backdrop: 'static',
      show: true,
      keyboard: false,
    });
    return this.deferred.promise;
  }

  public hide(status: OligoModalSupportStatus): void {
    if (!this.deferred) {
      return;
    }
    this.deferred.resolve(status);
  }

  private getJQ(): BootstrapJQ {
    if (!this.jq) {
      this.jq = $(`#${MODAL_ID}`) as BootstrapJQ;
    }
    return this.jq;
  }
}

export class OligoModalSupportController implements ng.IComponentController {

  public MODAL_ID: string = MODAL_ID;

  public data: OligoModalSupportOptions = {
    title: '',
    content: '',
    type: OligoModalTypes.INFO,
  };

  private jq?: BootstrapJQ;

  constructor($scope: ng.IScope, private oligoModalSupport: OligoModalSupport) {
    $scope.$watch(() => oligoModalSupport.data, (data?: OligoModalSupportOptions) => {
      if (!data) {
        return;
      }
      this.data = { ...data };
    });
  }

  public ok(): void {
    this.getJQ().modal('hide');
    this.oligoModalSupport.hide(OligoModalSupportStatuses.OK);
  }

  public cancel(): void {
    this.getJQ().modal('hide');
    this.oligoModalSupport.hide(OligoModalSupportStatuses.CANCEL);
  }

  public close(): void {
    this.getJQ().modal('hide');
    this.oligoModalSupport.hide(OligoModalSupportStatuses.CLOSE);
  }

  private getJQ(): BootstrapJQ {
    if (!this.jq) {
      this.jq = $(`#${MODAL_ID}`) as BootstrapJQ;
    }
    return this.jq;
  }

}
export const OLIGO_MODAL_SUPPORT_NAME: string = 'oligoModalSupport';
export const OligoModalSupportPanel: ng.IComponentOptions = {
  template: (() => {
    const bsJQ: BootstrapJQ = $.fn as BootstrapJQ;
    if (!bsJQ.modal || !bsJQ.modal.Constructor) {
      return '';
    }
    const version: string = bsJQ.modal.Constructor.VERSION;
    if (version) {
      if (version.indexOf('4') === 0) {
        return require('./oligo-modal-support.tpl.bs4.html');
      }
    } else {
      const isBS2: boolean = bsJQ.modal.toString().indexOf('bs.modal') === -1;
      if (isBS2) {
        return require('./oligo-modal-support.tpl.html');
      }
    }
    return '';
  })(),
  controller: OligoModalSupportController,
  controllerAs: 'modalSupport',
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/components/oligo-modal-support/oligo-modal-support.ts